import React, { memo, useRef, useEffect } from 'react';
import classes from './override.module.scss';

type Props = {
	button_display?: string;
	return_url?: string;
};

export const UnSupportedTemplate = memo((props: Props) => {
	const { button_display, return_url } = props;
	const returnTop = () => {
		const url = return_url ? return_url : '/';
		window.location.href = url;
	};

	const scrollRef = useRef(null);
	useEffect(() => {
		scrollRef.current.scrollIntoView();
		document.title = 'GakkenID ただいまの操作はお受けできませんでした';
	}, []);

	return (
		<>
			<section className="section">
				<div className="section-in" ref={scrollRef}>
					<div className="section-txt-box">
						<div className={classes.notFoundTitle}>IEは非対応ブラウザです。</div>
						<p>GoogleChromeやEdgeの最新版をご利用ください。</p>
					</div>
					<div className="btn-box">
						<div className="btn gr">
							<button onClick={returnTop}>{button_display ? button_display : `GakkenIDページTOPへ戻る`}</button>
						</div>
					</div>
				</div>
			</section>
		</>
	);
});
